module.exports = __webpack_public_path__ + "img/video_cover.7f205d09.jpeg";